import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpecTableComponent } from '../spec-table/spec-table.component';

@Component({
  selector: 'app-splitter-res-spec-table',
  templateUrl: './splitter-res-spec-table.component.html',
  styleUrls: ['./splitter-res-spec-table.component.scss']
})
export class SplitterResSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'totalPorts', 'occupancy', 'Splitter-id', 'Splitter-type'];
    super.onInit();
  }
}
